import APTipsUtils from "../ApTipsUtils";
import OverlayTips from "../OverlayTips";
import $ from 'jquery'


function LeaveTimePlanningPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

LeaveTimePlanningPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    $tipNotApproved: $(),
    $tipApproved: $(),

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        // Leave Time Requests tab
        this.add($("#leaveTimePlanningPage").find('.customHeaderTabs .tab').eq(1).find(".textTab"), {
            messageKey: "leave_time_planning.tips.tab.request",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 7,
            offsetY: 0
        });

        // Sorting parameters
        this.add($("#tipLTPSorting"), {
            messageKey: "leave_time_planning.tips.sorting",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 5,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: 0,
                offsetY: 5
            }
        });

        // BalancesViewer
        // noinspection DuplicatedCode Copy from MySchedulePageOverlayTipsManager
        this.add(function() {
            var $elem = $('#balancesViewerPlaceholder').find('.balancesViewer');
            var isPto = $elem.hasClass("showPTO");
            var isSick = $elem.hasClass("showSick");
            if (!isPto && !isSick) //don't show the tip
            {
                $elem = $();
                $elem.config = {};
            }
            else
            {
                var messageKey = isPto && isSick ?
                                 "my_schedule.tips.balances_viewer" :
                                 (isPto ? "my_schedule.tips.pto_balance_viewer" : "my_schedule.tips.sick_balance_viewer");
                $elem.config = {
                    messageKey: messageKey,
                    direction: OverlayTips.DIRECTION_TOP_LEFT,
                    offsetX: -6,
                    offsetY: -7
                };
            }
            return $elem;
        });

        this.add(_.bind(this._leaveWaitingApprovalTip, this));
        this.add(_.bind(this._leaveApprovedTip, this));
    },

    refreshDynamicTips: function(animated)
    {
        if (this.enabled)
            APTipsUtils.setLeaveChartTableTips(this, $('#leaveTimePlanningTablePlaceholder'));

        PageOverlayTipsManager.prototype.refreshDynamicTips.call(this, animated);
    },

    _leaveWaitingApprovalTip: function()
    {
        this.$tipNotApproved.config =
                _.defaults(this.$tipNotApproved.config || {}, {
                    messageKey: "leave_time_planning.tips.waiting_approval",
                    noFirstTimeAnimation: true,
                    offsetX: -5,
                    offsetY: 10
                });

        return this.$tipNotApproved;
    },

    _leaveApprovedTip: function()
    {
        this.$tipApproved.config =
                _.defaults(this.$tipApproved.config || {}, {
                    noFirstTimeAnimation: true,
                    messageKey: "leave_time_planning.tips.approved",
                    offsetX: -5,
                    offsetY: 10
                });

        return this.$tipApproved;
    }
});

export default LeaveTimePlanningPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/LeaveTimePlanningPageOverlayTipsManager.js